// frontend/src/components/ErrorBoundary.jsx
import React from 'react';
import posthog from 'posthog-js';
import { AlertCircle, RefreshCw } from 'lucide-react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('❌ ErrorBoundary a prins o eroare:', error, errorInfo);
    posthog.captureException(error, {
      component_stack: errorInfo?.componentStack,
    });
  }

  handleReset = () => {
    const err = this.state.error;
    const isChunk = err && /Loading chunk [\d]+ failed|ChunkLoadError|Failed to fetch dynamically imported module/i.test(err.message || String(err));
    if (isChunk) {
      window.location.reload();
      return;
    }
    this.setState({ hasError: false, error: null });
    window.location.href = '/home';
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="
          min-h-screen 
          bg-gradient-to-b from-base-100 to-base-200
          flex items-center justify-center
          px-4 py-8
          font-poppins
        ">
          <div className="
            max-w-md w-full
            bg-white/60 backdrop-blur-xl 
            rounded-3xl shadow-[0_8px_24px_rgba(213,111,62,0.18)]
            px-6 py-8
            text-center
            space-y-4
          ">
            <AlertCircle className="w-12 h-12 text-red-600 mx-auto" />
            <h2 className="text-xl font-semibold text-text-primary">
              Ceva nu a mers bine
            </h2>
            <p className="text-sm text-text-primary/70">
              A apărut o eroare neașteptată. Te rugăm să reîncerci sau să revii mai târziu.
            </p>
            {this.state.error && (
              <p className="text-xs text-red-400 mt-2 break-all px-2">
                {this.state.error.toString()}
              </p>
            )}
            <button
              onClick={this.handleReset}
              className="
                mt-4
                px-6 py-3
                bg-gradient-to-br from-accent to-accent
                text-white font-semibold rounded-xl
                hover:shadow-lg transition-all
                flex items-center justify-center gap-2 mx-auto
              "
            >
              <RefreshCw size={18} />
              <span>Reîncearcă</span>
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;